import { vcpuDto } from '../dto/vcpuDto';
import { tableViewModel } from '../views/tableViewModel';

export class vcpuTransformer {
  public static from(vcpu: vcpuDto): tableViewModel[] {
    return <tableViewModel[]>[
      {
        name: 'vCPU',
        value: vcpu.vcpuCount == null ? '-' : vcpu.vcpuCount
      },
      {
        name: 'CPU to vCPU Ratio',
        value:
          vcpu.vcpuClockSpeedToHostCPUClockSpeedRatio == null
            ? '-'
            : vcpu.vcpuClockSpeedToHostCPUClockSpeedRatio.toString()
      },
      {
        name: 'Core to vCPU Ratio',
        value:
          vcpu.vcpuCountToCoreCountRatio == null ? '-' : vcpu.vcpuCountToCoreCountRatio.toString()
      }
    ];
  }
}
